import { useState } from 'react'
import { toast } from 'sonner'
import { EnrollmentCard } from '@/components/training/EnrollmentCard'
import { Skeleton } from '@/components/ui/skeleton'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useCancelEnrollment, useMyEnrollments } from '@/hooks/use-training-enrollments'

const STATUS_TABS = [
  { value: 'all', label: 'すべて' },
  { value: 'active', label: '受講中' },
  { value: 'completed', label: '完了' },
  { value: 'follow_up', label: 'フォロー中' },
] as const

export default function MyEnrollmentsPage() {
  const [tab, setTab] = useState('all')
  const { data, isLoading } = useMyEnrollments()
  const cancelEnrollment = useCancelEnrollment()

  const enrollments = Array.isArray(data) ? data : []

  const filtered = enrollments.filter((e: any) => {
    if (tab === 'all') return true
    if (tab === 'active')
      return ['applied', 'pending_approval', 'confirmed', 'in_progress'].includes(e.status)
    if (tab === 'completed') return e.status === 'completed' || e.status === 'closed'
    if (tab === 'follow_up') return e.status === 'in_follow_up'
    return true
  })

  const handleCancel = async (enrollmentId: string) => {
    try {
      await cancelEnrollment.mutateAsync(enrollmentId)
      toast.success('受講をキャンセルしました')
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'キャンセルに失敗しました')
    }
  }

  if (isLoading) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">マイ受講</h1>
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-32" />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">マイ受講</h1>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          {STATUS_TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value={tab} className="mt-4">
          {filtered.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-muted-foreground">該当する受講はありません</p>
            </div>
          ) : (
            <div className="grid gap-4 md:grid-cols-2">
              {filtered.map((e: any) => (
                <EnrollmentCard
                  key={e.id}
                  id={e.id}
                  trainingId={e.trainingId}
                  trainingTitle={e.trainingTitle ?? e.training?.title ?? '研修'}
                  status={e.status}
                  enrolledAt={e.enrolledAt}
                  completedAt={e.completedAt}
                  onCancel={handleCancel}
                  isCancelling={cancelEnrollment.isPending}
                />
              ))}
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  )
}
